export default __webpack_public_path__ + "static/media/strasbourg15.0f906f73.jpg";